import { Button, Popover, styled } from '@mui/material';
import { format } from 'date-fns';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';
import { useCallback, useContext, useRef, useState } from 'react';
import { FrontSelect } from 'src/ui-components';

import { HeaderContext } from '../../../contexts/HeaderContext';
import { DateRange } from './dateRangeSelect/components/DateRange';

export const ComparativeSelect = () => {
  const ref = useRef(null);
  const {
    comparativeOptions,
    comparativeValue,
    setComparativeValue,
    setSelectedPreviousCustomDates,
  } = useContext(HeaderContext);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'customDateRange',
  });

  const [calDate, setCalDate] = useState<{
    startDate: Date;
    endDate: Date;
  }>({
    startDate: new Date(),
    endDate: new Date(),
  });

  const onApply = useCallback(() => {
    const newDate = {
      pc_s: format(calDate.startDate, 'yyyy-MM-dd'),
      pc_e: format(calDate.endDate, 'yyyy-MM-dd'),
    };

    setSelectedPreviousCustomDates(newDate);
    setComparativeValue(
      comparativeOptions.find((v: { label: string; value: string }) => v.value === 'pc'),
    );
    popupState.close();
  }, [
    calDate.endDate,
    calDate.startDate,
    comparativeOptions,
    popupState,
    setComparativeValue,
    setSelectedPreviousCustomDates,
  ]);

  const onClear = useCallback(() => {
    setCalDate({
      startDate: new Date(),
      endDate: new Date(),
    });
  }, []);

  const onComparativeChange = useCallback(
    (option: { value: string; label: string }) => {
      if (option.value === 'pc') {
        popupState.setAnchorEl(ref.current);
        popupState.open();
      } else setComparativeValue(option);
    },
    [popupState, setComparativeValue],
  );

  return (
    <Wrapper aria-describedby={'customDateRange'} ref={ref}>
      <FrontSelect
        placeholder="Select Date to Compare"
        value={comparativeValue}
        options={comparativeOptions}
        onChange={(option) => onComparativeChange(option)}
        name="compareSelect"
        isMulti={false}
        isSearchable={false}
        isLoading={false}
      />
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PopoverWrapper>
          <Header>
            <Button size={'small'} variant={'contained'} onClick={onClear} color="inherit">
              Clear Filter
            </Button>
            <Button size={'small'} variant={'contained'} onClick={onApply} color="primary">
              Apply Time Range
            </Button>
          </Header>
          <DateRange range={calDate} onChange={(r) => setCalDate({ ...r })} />
        </PopoverWrapper>
      </Popover>
    </Wrapper>
  );
};

const Wrapper = styled('div')``;
const PopoverWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 16px 0 16px 8px;
`;

const Header = styled('div')`
  display: flex;
  gap: 8px;
  justify-content: end;
  margin-right: 8px;
`;
